import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const StyledIcon = styled.svg`
  width: 100%;
  height: 100%;
  display: inline-block;
  vertical-align: middle;
  fill: currentColor;
`;

const Icon = props => {
  const { icon, className } = props;
  return (
    <StyledIcon
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
    >
      <use xlinkHref={`${icon}`} />
    </StyledIcon>
  );
};

Icon.propTypes = {
  icon: PropTypes.string.isRequired,
  className: PropTypes.string,
};

export default Icon;



// WEBPACK FOOTER //
// ./src/icons/Icon.js